export const upload = {
  pathname: '/private/files',
  method: 'POST',
  body: ({ file }) => file
}

export const behaviours = {
  pathname: ({ id }) => `/private/files/${id}/behaviour_summary`,
  method: 'GET'
}
